'use client';
import Disclosure from "./Disclosure.js";
export default Disclosure;